import { render, staticRenderFns } from "./setLuxRadius.vue?vue&type=template&id=a4a70bbc&scoped=true"
import script from "./setLuxRadius.vue?vue&type=script&lang=js"
export * from "./setLuxRadius.vue?vue&type=script&lang=js"
import style0 from "./setLuxRadius.vue?vue&type=style&index=0&id=a4a70bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a70bbc",
  null
  
)

export default component.exports